import { render, staticRenderFns } from "./uniformDetail.vue?vue&type=template&id=474851da&scoped=true&"
import script from "./uniformDetail.vue?vue&type=script&lang=js&"
export * from "./uniformDetail.vue?vue&type=script&lang=js&"
import style0 from "./uniformDetail.vue?vue&type=style&index=0&id=474851da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474851da",
  null
  
)

export default component.exports